import { LOGIN_ROUTE, REQUEST_LIST_ROUTE, RESOLUTION, EQUIPMENT_INDICATOR_LIST_ROUTE } from "../../routes";
import {authRoutes, publicRoutes} from "../../routes";
import React, {useEffect} from 'react';
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom'
import {useSelector} from "react-redux";
import { useMemo } from "react";
import useRoles from "../../hooks/useRoles";
import { isPublicProtocolSee } from "../../functions/renderProtocol";

const AppRouter = () => {
    let hasToken = !!localStorage.getItem("token") &&
        localStorage.getItem("token") != "null";    
    const isAuth = useMemo(()=>{
        return hasToken;
    }, [hasToken]);
    const { isCommittee, roles } = useRoles();
    const { search } = useLocation();
    const location = useLocation().pathname;

    const history = useHistory();

  const knownRoute = (authRoutes?.find((_) => {
      if (!_.path) return false;
      if (_.path === location) return true;
      if (location.startsWith(_.path.replace(/\/:[^/]+/g, "")) && _.path.includes(":")) {
        const pattern = "^" + _.path.replace(/:[^/]+/g, "[^/]+") + "$";
        return new RegExp(pattern).test(location);
      }
      return _.path.startsWith(location);
    }) != null ||
        publicRoutes?.find(_ => _.path?.startsWith(location)) != null) && location != '/';
    const protocolSee = isPublicProtocolSee("/protocolList", search);
    const defaultAuthedRoute = useMemo(() => {
        if (isCommittee()) return RESOLUTION;

        // Users with only Metrolog/SMK roles start in the equipment indicator.
        const indicatorOnlyRoles = ["Metrolog", "SMK"];
        const isIndicatorOnlyUser = roles.length > 0 &&
            roles.every((role) => indicatorOnlyRoles.includes(role));

        if (isIndicatorOnlyUser) {
            return EQUIPMENT_INDICATOR_LIST_ROUTE;
        }

        return REQUEST_LIST_ROUTE;
    }, [roles, isCommittee]);

    return (
        <div>
            <Switch>                
                {isAuth && authRoutes.map(({path, Component}) =>
                    <Route key={path} path={path} component={Component} exact/>
                )}
                {publicRoutes.map(({path, Component}) =>
                    <Route key={path} path={path} component={Component} exact/>
                )}
                {!knownRoute && <Redirect to={defaultAuthedRoute}/>}                
                {!isAuth && !protocolSee && <Redirect to={LOGIN_ROUTE}/>}
            </Switch>
        </div>
    );
};

export default AppRouter;